import React, {useContext, useState, useEffect} from 'react'
import {Routes, Route } from "react-router-dom";
import { GlobalState } from '../GlobalState';

import NotFound404 from '../pages/notFound404'
import CreateQR from "../pages/CreateQR";
import Home from "../pages/QR";
import QRDocument from "../pages/QRDocument";
import CreateMultiQR from "../pages/CreateMultiQR";
import LoginUser from './LoginUser';
import Header from './layouts/header';
import Footer from './layouts/footer';

function App() {
  const state = useContext(GlobalState)
  const [islogged] = state.isAuthenticated
  const [checked, setChecked] = useState(false)

  useEffect(()=>{
    const checkLogin = ()=>{
      if(sessionStorage.getItem('islogged')){
        setChecked(true)
      }
    }
    checkLogin()
  })

  return (
<>
  {checked ? (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/create-qr" element={<CreateQR />} />
        <Route path="/qr-document" element={<QRDocument />} />
        <Route path="/create-multi-qr" element={<CreateMultiQR />} />
        <Route path="*" element={<NotFound404 />} />
      </Routes>
      <Footer />
    </>
  ) : (
    <LoginUser />
  )}
</>

  );
}

export default App;